import { Typography } from '@sanlam-glacier/app-common/components';
import EventsWidget from '../components/molecules/widgets/content/events/EventsWidget';
import HotLinksWidget from '../components/molecules/widgets/content/hotlinks/HotLinksWidget';
import PortfolioSummaryWidget from '../components/molecules/widgets/content/portfolio-summary/PortfolioSummaryWidget';
import TableWidget from './TableRenderer';
import { WidgetType } from 'modules/dashboard/types/widgets/widget.enums';
import BankAccountsWidget from '../components/molecules/widgets/content/bank-accounts/BankAccountsWidget';
import BeneficiariesWidget from '../components/molecules/widgets/content/beneficiaries/BeneficiariesWidget';
import { InvestmentBreakdownWidget } from '../components/molecules/widgets/content/investment-breakdown/InvestmentBreakdownWidget';
import PersonalDetailsWidget from '../components/molecules/widgets/content/personal-details/PersonalDetailsWidget';
import ChartWidget from '../utils/chart/ChartWidget';
import { TopAssetManagersWidget } from '../components/molecules/widgets/content/asset-managers/TopAssetManagersWidget';
import BookSummaryWidget from '../components/molecules/widgets/content/book-summary/BookSummary';
import TopFundsWidget from '../components/molecules/widgets/content/top-funds/TopFundsWidget';
import { ExtendedGridLayout } from '../components/organisms/grid-layout/GridLayoutShell';
import { ToDoList } from '../components/molecules/widgets/content/to-do-list/ToDoList';

export const WidgetRenderer = ({
  widget,
  hotLinksData
}: {
  widget: ExtendedGridLayout;
  hotLinksData: { path: string; label: string; icon: string }[];
}) => {
  switch (widget?.widgetProps?.widgetConfig.type) {
    case WidgetType.personalDetails:
      return <PersonalDetailsWidget />;
    case WidgetType.hotlinks:
      return <HotLinksWidget links={hotLinksData} />;
    case WidgetType.events:
      return <EventsWidget />;
    case WidgetType.portfolioSummary:
      return <PortfolioSummaryWidget />;
    case WidgetType.bankAccounts:
      return <BankAccountsWidget />;
    case WidgetType.bookSummary:
      return <BookSummaryWidget />;
    case WidgetType.table:
      return renderTableWidget(widget);
    case WidgetType.lineChart:
      return renderChartWidget(widget);
    case WidgetType.investmentBreakdown:
      return <InvestmentBreakdownWidget />;
    case WidgetType.gaugeChart:
      return renderChartWidget(widget);
    case WidgetType.beneficiaries:
      return <BeneficiariesWidget />;
    case WidgetType.topAssetManagers:
      return <TopAssetManagersWidget />;
    case WidgetType.topFunds:
      return <TopFundsWidget />;
    case WidgetType.todoList:
      return <ToDoList />;
    default:
      return <InvalidData message='Widget' />;
  }
};

const renderTableWidget = (widget: ExtendedGridLayout) => {
  const props = widget.tableProps;
  if (!props) return <InvalidData message='Table' />;
  return <TableWidget tableType={props.tableType} data={props.data} />;
};

const renderChartWidget = (widget: ExtendedGridLayout) => {
  const props = widget.chartProps;
  if (!props) return <InvalidData message='Chart' />;
  return <ChartWidget {...props} />;
};

const InvalidData = ({ message }: { message: string }) => (
  <Typography
    variant={Typography.VARIANT.B3}
    weight={Typography.WEIGHT.LIGHT}
    color={Typography.COLOR.SECONDARY}
  >
    Invalid Data for {message}
  </Typography>
);
